<template>
  <div>
    <nav-title :color="false" :title="'Home Challenge'" />
    <select-child :users="getChildrenData" :router="url" />
  </div>
</template>
<script>
import navTitle from '@/components/general/navTitle.vue';
import selectChild from '@/components/general/selectChild.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      url: this.$route.query.next,
    };
  },
  components: {
    navTitle,
    selectChild,
  },
  computed: {
    ...mapGetters('parent', ['getChildrenData']),
  },
  created() {
    let childrenActive = this.getChildrenData.filter((child) => child.child_enabled);

    if (childrenActive.length == 1) {
      this.$router.push(`${this.url}/${childrenActive[0].id}`);
    }
  },
};
</script>
